<template>
    <div id="app">
        <div class="loading" v-if="isLoading">
            <img src="https://www.3dreal.com/assets/3dreal-loading.gif" />
        </div>
        <div class="bf-logo">
            <img src="~@/assets/image/3dreal-logo@2x.png" />
        </div>
        <div id="panorama"></div>
        <modal
                :title="title"
                :is-show="show"
                :show-ok="false"
                :show-footer="false"
                transition="fadeDown"
                @close="show = false"
        >
            <div style="height:100%">
                <iframe style="width: 100%;height:100%" :src="iframeSrc" />
            </div>
        </modal>
        <music-con />
    </div>
</template>
<script>
    import musicCon from "@/components/music-con";
    export default {
        name: "App",
        components: {
            musicCon
        },
        data() {
            return {
                show: false,
                title: "",
                iframeSrc: "",
                isLoading: true
            };
        },
        mounted() {
            // eslint-disable-next-line no-undef
            let viewer = pannellum.viewer("panorama", {
                //Pannellum支持四种处理全景图片的方式：equirectangular,partial,cubic,multi-resolution
                allow_user_interactions: false,
                // hotSpotDebug:true,
                firstScene: "circle", //首次加载那个图片
                sceneFadeDuration: 1000, //全景图场景切换时的持续时间
                autoLoad: true, //自动加载
                panorama: "https://pannellum.org/images/tocopilla.jpg",
                showControls: false, //是否显示控制按钮，默认true；
                autoRotate: -2, //是否自动旋转，在加载之后，全景图会水平旋转显示，负数为往右边旋转，整数为往左边旋转，值为数字类型；
                //场景，值为对象，其属性名代表着场景的id（sceneId），属性值为viewer的配置参数，其参数会覆盖默认（上述中的default对象）设置的参数；
                pitch: -29,
                yaw: -151,
                hfov: 100.0,
                type: "multires",
                multiRes: {
                    basePath: "./image/printer",
                    "path": "/%l/%s%y_%x",
                    "fallbackPath": "/fallback/%s",
                    "extension": "jpg",
                    "tileResolution": 256,
                    "maxLevel": 6,
                    "cubeResolution": 4160
                },
                hotSpots: [
                    //热点，以全景为坐标系的固定点，可以设置链接跳转和点击事件，也可以跳转到不同的场景，该属性的值为对象
                    {
                        pitch: 6.838075988937479,
                        yaw: -5.933672315016197,
                        type: "info",
                        cssClass: "shou1",
                        text: "鸿美热升华转印墨水100ML",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1270599800191275009'
                    },
                    {
                        pitch: 11.272064771773342,
                        yaw: 116,
                        type: "info",
                        cssClass: "shou1",
                        text: "百度西500ML照片连供墨水",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1270943175595610113'
                    },
                    {
                        pitch: -21.272064771773342,
                        yaw: -48,
                        type: "info",
                        cssClass: "shou1",
                        text: "另色鬼100ML连供通用墨水",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1270559291955564545'
                    },
                    {
                        pitch: -5.272064771773342,
                        yaw: 5,
                        type: "info",
                        cssClass: "shou1",
                        text: "影像专用染料墨水",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1270605601437995009'
                    },
                    {
                        pitch: -33.272064771773342,
                        yaw: -160,
                        type: "info",
                        cssClass: "shou1",
                        text: "墨仓式L805  6色WIFI照片打印机",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1268130038173487105'
                    },
                    {
                        pitch: -20.272064771773342,
                        yaw: -143,
                        type: "info",
                        cssClass: "shou1",
                        text: "墨仓式M105 黑白无线打印机",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1268146110838689793'
                    },
                    {
                        pitch: -3.272064771773342,
                        yaw: 147,
                        type: "info",
                        cssClass: "shou1",
                        text: "MBrush手持打印机喷墨彩色",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1270209246362161153'
                    },
                    {
                        pitch: -24.272064771773342,
                        yaw: 1,
                        type: "info",
                        cssClass: "shou1",
                        text: "相馆影楼摆摊热转印打印机",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1270975460525035521'
                    },
                    {
                        pitch: -12.272064771773342,
                        yaw: -122,
                        type: "info",
                        cssClass: "shou1",
                        text: "Canon/佳能 iX6780 A3+商用打印机",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1270316477598486530'
                    },
                    {
                        pitch: -33.272064771773342,
                        yaw: 167,
                        type: "info",
                        cssClass: "shou1",
                        text: "墨仓式L3158彩色无线WIFI多功能一体机",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1270293408209260546'
                    },
                    {
                        pitch: -32.272064771773342,
                        yaw: 136,
                        type: "info",
                        cssClass: "shou1",
                        text: "墨仓式L3119 A4彩色多功能一体机",
                        URL: 'http://1268062615864954882.mobileshop.3dreal.com/dashboard/home/detail?id=1268108081721856002'
                    },
                    // {
                    //     pitch: -2.254943554243,
                    //     yaw: 7.31114874435126,
                    //     type: "info",
                    //     cssClass: "shou1",
                    //     text: "伊斯兰女长裙¥1999.00",
                    //     URL:
                    //         "http://1215156752334843906.mobileshop.3dreal.com/dashboard/home/detail?id=1262366152048590849"
                    // },
                    // {
                    //     pitch: -32.254943554243,
                    //     yaw: 158.31114874435126,
                    //     type: "info",
                    //     cssClass: "shou1",
                    //     text: "法式高跟鞋女细跟2020款夏季百搭¥1999.00",
                    //     clickHandlerFunc: () => {
                    //         this.iframeSrc =
                    //             "http://www.3dreal.com/audit?id=871&type=1&sign=c446bce065a5ffc75d92389727faccd7";
                    //         this.show = true;
                    //         this.title = "法式高跟鞋女细跟2020款夏季百搭";
                    //     }
                    // },
                    // {
                    //     pitch: -16.038349112976878,
                    //     yaw: -141.93480712161175,
                    //     type: "info",
                    //     cssClass: "shou1",
                    //     text: "2020夏季新款收腰清凉短袖连衣裙¥1599.00",
                    //     clickHandlerFunc: () => {
                    //         this.iframeSrc =
                    //             "http://www.3dreal.com/audit?id=880&type=1&sign=6e9ce13db070d74c06a9226345ecb7e8";
                    //         this.show = true;
                    //         this.title = "2020夏季新款收腰清凉短袖连衣裙";
                    //     }
                    // },
                    // {
                    //     pitch: 0.6210766442133998,
                    //     yaw: -165.7100349456342,
                    //     type: "info",
                    //     cssClass: "shou1",
                    //     text: "长款祺旗袍2020新款年轻款中国风优雅¥1999.00",
                    //     clickHandlerFunc: () => {
                    //         this.iframeSrc =
                    //             "http://www.3dreal.com/audit?id=549&type=1&sign=793e23f86a074f44f930b3d20199f732";
                    //         this.show = true;
                    //         this.title = "长款祺旗袍2020新款年轻款中国风优雅";
                    //     }
                    // },
                    // {
                    //     pitch: -9.876415059535173,
                    //     yaw: -131.23672719492265,
                    //     type: "info",
                    //     cssClass: "shou1",
                    //     text: "2020夏季新款短袖T恤纯色清凉¥999.00",
                    //     clickHandlerFunc: () => {
                    //         this.iframeSrc =
                    //             "http://www.3dreal.com/audit?id=859&type=1&sign=e25391d3ab545ff0adba54b154ee17ba";
                    //         this.show = true;
                    //         this.title = "2020夏季新款短袖T恤纯色薄清凉";
                    //     }
                    // },
                    // {
                    //     pitch: -38, //定位参数， 单位：角度
                    //     yaw: -88, //定位参数， 单位：角度 y轴，空间中的纵轴
                    //     type: "info", //热点类型，scene 场景切换热点； info 信息展示；URL 以热点为链接，跳转到其他页面的`url
                    //     text: "进入潮鞋馆",
                    //     cssClass: "arrow",
                    //     URL: window.location.origin + "/shoes"
                    // }
                ]
            });
            window.addEventListener("load", () => {
                setTimeout(() => {
                    this.isLoading = false;
                    var ele = document.querySelectorAll('.shou1')
                    console.log(ele);
                }, 1000);
            });
            console.log(viewer);
        },
        methods: {
        }
    };
</script>
<style>
    .pnlm-ui .pnlm-about-msg {
        display: none !important;
    }

    .pnlm-ui .pnlm-orientation-button {
        display: none !important;
    }
    .pnlm-lmsg {
        display: none;
    }
</style>
<style lang="less">
    body {
        margin: 0;
        padding: 0;
    }
    #app {
        .bf-logo {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
        }
    }
    #panorama {
        height: 100vh;
    }
    .shou1 {
        background-image: url("../../assets/image/10.png");
        width: 50px;
        height: 50px;
        background-size: 50px 300px;
        animation: show1 0.3s infinite step-start;
    }
    @keyframes show1 {
        0% {
            background-position: 0 0;
        }
        25% {
            background-position: 0 -250px;
        }
        50% {
            background-position: 0 -150px;
        }
        75% {
            background-position: 0 -150px;
        }
        100% {
            background-position: 0 0;
        }
    }
    .arrow {
        background-image: url("../../assets/image/arrow.png");
        width: 64px;
        height: 64px;
        background-size: 64px 1600px;
        animation: arrow 0.8s infinite step-start;
    }
    @keyframes arrow {
        0% {
            margin-top: 0;
        }
        25% {
            margin-top: -5px;
        }
        50% {
            margin-top: -10px;
        }
        75% {
            margin-top: -15px;
        }
        100% {
            margin-top: -20px;
        }
    }
    .loading {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: -webkit-box;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        z-index: 100;
        background-color: #fff;
        img {
            width: 22%;
            height: auto;
        }
    }
</style>
